import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { HeartIcon } from 'lucide-react';
export function Proof() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-gradient-to-b from-white to-cream py-16 md:py-24 px-6" data-id="element-150">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.7
    }} className="max-w-4xl mx-auto" data-id="element-151">
        <div className="text-center mb-8" data-id="element-152">
          <HeartIcon className="w-12 h-12 text-terracotta mx-auto mb-6" data-id="element-153" />
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-warm-brown mb-6" data-id="element-154">
            Lo que cambia en 7 días
          </h2>
        </div>

        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-2xl border-l-4 border-terracotta" data-id="element-155">
          <p className="text-xl md:text-2xl text-warm-brown leading-relaxed font-light" data-id="element-156">
            No solo es que tu bebé duerma; es que{' '}
            <strong data-id="element-157">tú dejas de tener miedo a la noche</strong>. En una semana,
            la ansiedad de las 7:00 PM desaparece porque sabes que tienes un
            plan que funciona. Tu energía regresa, tu humor mejora y vuelves a
            disfrutar la maternidad en lugar de solo sobrevivirla.
          </p>
        </div>
      </motion.div>
    </section>;
}